module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("Part 1: Overview of Gender Identity in Therapy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" Religious Identity and Gender Identity in Therapy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" Assessment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" Discussing the Gender and Religious Identity Therapy Approach with Clients")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Therapy Postures and Gestures—Children")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" Gender Patience")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" Approaching Puberty: Answering Questions Around Puberty Blockers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Therapy Tools—Adolescents and Adults")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" Adolescence: A Brief Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v(" The Journey to Find “Me”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" A Multitier Distinction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v(" Identifying Scripts and Storylines")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v(" Chapters in One’s Life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v(" Sojourners and Traveling Companions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v(" Unpacking Feelings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v(" Where Is God?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14")]), _vm._v(" Coping and Management Strategies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4: Case Studies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15")]), _vm._v(" Individual: The Case of Kelly")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("16")]), _vm._v(" Couples Therapy: The Case of Ben (Bea) and Elodie")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("17")]), _vm._v(" Individual Therapy: The Case of Rae")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Gender Identity and Faith")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0